module.exports = __webpack_public_path__ + "static/media/icone_newbot.720196cb.svg";